import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Download, ArrowLeft, Eye, EyeOff } from 'lucide-react';
import './SoulProject.css';

function Certificates() {
    const navigate = useNavigate();
    const [password, setPassword] = useState('');
    const [showCertificates, setShowCertificates] = useState(false);
    const [error, setError] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    const CERTIFICATE_PASSWORD = process.env.REACT_APP_CERTIFICATE_PASSWORD || '';

    const handleSubmit = (e) => {
        e.preventDefault();
        if (password === CERTIFICATE_PASSWORD) {
            setShowCertificates(true);
            setError('');
        } else {
            setError('Invalid password!');
        }
    };

    const certificates = [
        { name: 'SSLC Certificate', file: 'SSLC.pdf' },
        { name: '+2 Certificate', file: '+2-CERTIFICATE.pdf' },
        { name: 'Passbook', file: 'Passbook.pdf' },
        { name: 'EAadhaar', file: 'EAadhaar.pdf' }
    ];

    return (
        <div className="soul-project">
            {/* Header */}
            <header className="project-header">
                <button onClick={() => navigate('/#contact')} className="back-btn">
                    <ArrowLeft size={20} /> Back to Portfolio
                </button>

                <div className="project-hero">
                    <span className="project-tag">Certificates</span>
                    <h1>Academic & Professional Certificates</h1>
                    <p className="tagline">
                        Secure access to verified academic and professional certificates
                    </p>
                </div>
            </header>

            {!showCertificates ? (
                <section className="section">
                    <div className="overview-content" style={{ textAlign: 'center', padding: '4rem 2rem' }}>
                        <h2>Certificate Access Portal</h2>
                        <p style={{ color: 'var(--text-muted)', maxWidth: '600px', margin: '0 auto 2rem' }}>
                            To view and download certificates, please enter the secure access password.
                        </p>
                        <form onSubmit={handleSubmit} style={{ maxWidth: '400px', margin: '0 auto' }}>
                            <div style={{ marginBottom: '1.5rem' }}>
                                <label htmlFor="password" style={{ display: 'block', marginBottom: '0.5rem', color: 'var(--text-secondary)' }}>
                                    Access Password
                                </label>
                                <div style={{ position: 'relative' }}>
                                    <input
                                        type={showPassword ? 'text' : 'password'}
                                        id="password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        placeholder="Enter password"
                                        style={{
                                            width: '100%',
                                            padding: '1rem',
                                            paddingRight: '3rem',
                                            border: '1px solid rgba(255, 255, 255, 0.15)',
                                            borderRadius: '12px',
                                            background: 'var(--card-bg)',
                                            color: 'var(--text-primary)',
                                            fontSize: '1rem',
                                            backdropFilter: 'blur(20px)'
                                        }}
                                    />
                                    <button
                                        type="button"
                                        onClick={() => setShowPassword(!showPassword)}
                                        aria-label={showPassword ? "Hide password" : "Show password"}
                                        style={{
                                            position: 'absolute',
                                            right: '1rem',
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                            background: 'transparent',
                                            border: 'none',
                                            cursor: 'pointer',
                                            color: 'var(--text-secondary)',
                                            padding: '0.5rem',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}
                                    >
                                        {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                                    </button>
                                </div>
                            </div>
                            {error && (
                                <p role="alert" style={{ color: '#ff6b9d', textAlign: 'center', marginTop: '0.5rem' }}>
                                    {error}
                                </p>
                            )}
                            <button type="submit" style={{
                                width: '100%',
                                padding: '1rem',
                                background: 'var(--gradient-blue)',
                                color: '#000',
                                border: 'none',
                                borderRadius: '12px',
                                fontWeight: '600',
                                fontSize: '1rem',
                                cursor: 'pointer',
                                transition: 'all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)'
                            }}>
                                Access Certificates
                            </button>
                        </form>
                    </div>
                </section>
            ) : (
                <>
                    <section className="section">
                        <div className="overview-content">
                            <h2>Available Certificates</h2>
                            <p style={{ color: 'var(--text-muted)', marginBottom: '2rem' }}>
                                Select a certificate below to view or download:
                            </p>
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '1.5rem' }}>
                                {certificates.map((cert, index) => (
                                    <div key={index} className="feature-card">
                                        <div style={{ textAlign: 'center', padding: '2rem' }}>
                                            <Download size={48} style={{ color: 'var(--primary)', marginBottom: '1rem' }} />
                                            <h4>{cert.name}</h4>
                                             <p style={{ color: 'var(--text-muted)', marginTop: '1rem' }}>
                                                  <a href={`certificates/${cert.file}`} target="_blank" rel="noopener noreferrer" 
                                                    className="link-text"
                                                    aria-label={`Download ${cert.name} PDF`}>
                                                    Download PDF
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </section>

                    <footer className="project-footer">
                        <p>© {new Date().getFullYear()} Anjoe James. Certificate Access Portal.</p>
                    </footer>
                </>
            )}
        </div>
    );
}

export default Certificates;